import { createContext, useContext, useEffect, useState } from "react";

const GuestCartContext = createContext();
const STORAGE_KEY = "a1_rugs_guest_cart";

export const useGuestCart = () => useContext(GuestCartContext);

export default function GuestCartProvider({ children }) {
  const [guestCart, setGuestCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(guestCart));
    window.dispatchEvent(new Event("guestCartUpdated"));
  }, [guestCart]);

  const addGuestItem = (product, size) => {
    if (!product?.id || !size?.id) throw new Error("A product and size are required.");
    if (product.is_sold) throw new Error("This product has already been sold.");
    setGuestCart((current) => {
      if (current.some((item) => Number(item.product) === Number(product.id) && Number(item.size?.id) === Number(size.id))) return current;
      const originalPrice = Number(size.price || 0);
      const discountPrice = size.discount_price !== null && size.discount_price !== undefined ? Number(size.discount_price) : null;
      const price = discountPrice !== null && discountPrice < originalPrice ? discountPrice : originalPrice;
      return [...current, { product: Number(product.id), product_name: product.name, product_image: product.sub_images?.[0]?.image || product.image || null, size: { id: Number(size.id), length_cm: size.length_cm, width_cm: size.width_cm, length_ft: size.length_ft, width_ft: size.width_ft, price: originalPrice, discount_price: discountPrice }, quantity: 1, price }];
    });
  };

  const removeGuestItem = (productId, sizeId) => setGuestCart((current) => current.filter((item) => !(Number(item.product) === Number(productId) && Number(item.size?.id) === Number(sizeId))));
  const updateGuestQuantity = (productId, sizeId, quantity) => { if (quantity <= 0) removeGuestItem(productId, sizeId); };
  const clearGuestCart = () => setGuestCart([]);
  const cartCount = guestCart.length;
  const cartTotal = guestCart.reduce((total, item) => total + Number(item.price || 0), 0);

  return <GuestCartContext.Provider value={{ guestCart, cartCount, cartTotal, addGuestItem, updateGuestQuantity, removeGuestItem, clearGuestCart }}>{children}</GuestCartContext.Provider>;
}
